import { Container, Grid, makeStyles, Paper, Typography } from '@material-ui/core'
import { FC, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import useTranslate from '../i18n/useTranslate'
import Form from '../component/um/settingREC/form'
import { useHistory } from 'react-router-dom'
import { useSettingREC } from '../services/um/useSettingREC'
import Dialog, { DialogType } from '../control/dialog/dialog'
import useAuthenStore from '../stores/authen/authenStore'

interface SettingRECEditProps {}
export type FormType = {
    nameTH: string | null
    nameEN: string | null
    recID: string | null
    addressTH: string | null
    addressEN: string | null
    telephone: string | null
    email: string | null

    headerCertificateEN: string | null
    headerCertificateTH: string | null
    headerMemorandumEN: string | null
    headerMemorandumTH: string | null
    organizationEN: string | null
    organizationTH: string | null
}
const SettingRECEdit: FC<SettingRECEditProps> = ({}) => {
    const classes = useStyle()
    const translate = useTranslate()
    const history = useHistory()
    const authenStore = useAuthenStore()
    const params = useParams<{ id: string }>()
    const { settingREC, putSettingREC } = useSettingREC(Number(params.id))
    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()

    let initialValues: FormType = {
        nameTH: settingREC?.nameTH || null,
        nameEN: settingREC?.nameEN || null,
        recID: String(settingREC?.recID) || null,
        addressTH: settingREC?.addressTH || null,
        addressEN: settingREC?.addressEN || null,
        telephone: settingREC?.telephone || null,
        email: settingREC?.email || null,

        headerCertificateEN: settingREC?.headerCertificateEN || null,
        headerCertificateTH: settingREC?.headerCertificateTH || null,
        headerMemorandumEN: settingREC?.headerMemorandumEN || null,
        headerMemorandumTH: settingREC?.headerMemorandumTH || null,
        organizationEN: settingREC?.organizationEN || null,
        organizationTH: settingREC?.organizationTH || null,
    }

    const onSubmit = (value: FormType) => {
        setConfigDialog({
            title: `${translate.get('UM.SETTINGREC.MESSAGE.HEADER')}`,
            content: `${translate.get('UM.SETTINGREC.MESSAGE.CONFIRM')}`,
            type: 'alert-confirm',
            onClickConfirm: () => onSave(value),
        })

        dialogTwoRef.current?.openDialog()
    }

    const onSave = async (value: FormType) => {
        let values = {
            nameTH: value.nameTH || null,
            nameEN: value.nameEN || null,
            recID: value.recID || null,
            userID: authenStore.profile.userId ?? 0,
            addressTH: value?.addressTH || null,
            addressEN: value?.addressEN || null,
            telephone: value?.telephone || null,
            email: value?.email || null,

            headerCertificateEN: value?.headerCertificateEN || null,
            headerCertificateTH: value?.headerCertificateTH || null,
            headerMemorandumEN: value?.headerMemorandumEN || null,
            headerMemorandumTH: value?.headerMemorandumTH || null,
            organizationEN: value?.organizationEN || null,
            organizationTH: value?.organizationTH || null,
        }

        const data = await putSettingREC(Number(params.id), values)

        if (data.message === 'duplicated') {
            setConfigDialog({
                title: `${translate.get('UM.SETTINGREC.MESSAGE.HEADER')}`,
                content: `${translate.get('UM.SETTINGREC.MESSAGE.DUPLICATED')}`,
                type: 'alert-message',
            })
            dialogTwoRef.current?.openDialog()
        }

        if (data.message === 'success') {
            setConfigDialog({
                title: `${translate.get('UM.SETTINGREC.MESSAGE.HEADER')}`,
                content: `${translate.get('UM.SETTINGREC.MESSAGE.SUCCESS')}`,
                type: 'alert-message',
                onAfterClose: () => history.push('/settingREC'),
            })
            dialogTwoRef.current?.openDialog()
        }
    }

    const onBack = () => {
        history.goBack()
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    return (
        <Container maxWidth="lg">
            <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: '20px' }}>
                {translate.get('UM.SETTINGREC.EDIT.HEADER')}
            </Typography>
            <Paper className={classes.paper}>
                <Form onClickBack={onBack} initialValues={initialValues} onSubmit={onSubmit} />
            </Paper>
            <Dialog onRef={onRefDialogTwo} {...configDialog} />
        </Container>
    )
}
export default SettingRECEdit

const useStyle = makeStyles((theme) => ({
    container: {
        width: '100%',
    },
    paper: {
        width: '100%',
        padding: '20px',
        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'unset',
            boxShadow: 'unset',
            margin: '0px',
        },
    },
}))
